<div class="modal-header">
    <h4 class="modal-title">Chat y registros de la solicitud </h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<mat-dialog-content class="chat-content">
    <div class="modal-body">
        <section class="chat w-100">
            <div class="messages-chat p-2">
                <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center p-5">
                  
                </div>
                <div *ngIf="!isLoading && history.length === 0" class="text-center p-5">
                    <p>No hay historial para mostrar.</p>
                </div>
                <ng-template ngFor let-log [ngForOf]="history">
                    <div *ngIf="log.type == 'reg'" class="message">
                        <p class="text system bg-purple text-white">
                            <mat-icon class="align-middle" matTooltip="Mensaje de sistema" [matTooltipPosition]="'above'">info</mat-icon> 
                            <span [innerHTML]="log.content"></span>
                            <span class="user-name">Por: {{log.name}} - <span class="badge bg-warning">{{ log.rol }}</span></span>
                            <small>{{log.created_at | date : "dd/MM/yyyy hh:mm a" :"+0000"}}</small>
                        </p>                        
                        <a *ngIf="log.type == 'reg' && log.content.includes('href')" [href]="log.content" target="_blank" class="d-block mt-2">
                            <mat-icon>download</mat-icon> Descargar archivo
                        </a>
                    </div>
                    <div *ngIf="log.type == 'msg' && log.id_rol != 1 && log.id_rol != 2" class="message">
                        <div class="photo" [ngStyle]="{'background-image': getLogoCompany(log.imagen) }"></div>
                        <p class="text">
                            <span [innerHTML]="log.content"></span>
                            <small>{{log.created_at | date : "dd/MM/yyyy hh:mm a" :"+0000"}}</small>
                        </p>
                    </div>
                    <div *ngIf="log.type == 'img' && log.id_rol != 1 && log.id_rol != 2" class="message">
                        <div class="photo" [ngStyle]="{'background-image': getLogoCompany(log.imagen) }"></div>
                        <div class="text">
                            <a [href]="log.content" target="_blank">
                                <img [src]="log.content" alt="Imagen adjunta" class="img-fluid" *ngIf="isImage(log.content); else fileLink">
                                <ng-template #fileLink>
                                    <mat-icon>attach_file</mat-icon> {{ log.namereg || 'Descargar archivo' }}
                                </ng-template>
                            </a>
                            <small>{{log.created_at | date : "dd/MM/yyyy hh:mm a" :"+0000"}}</small>
                        </div>
                    </div>
                    <div *ngIf="log.type == 'msg' && (log.id_rol == 1 || log.id_rol == 2)" class="message">
                        <div class="response"> 
                            <p class="text"><span [innerHTML]="log.content"></span><small>{{log.created_at | date : "dd/MM/yyyy hh:mm a" :"+0000"}}</small></p>
                        </div>
                        <div class="photo buho"></div>
                    </div>
                    <div *ngIf="log.type == 'img' && (log.id_rol == 1 || log.id_rol == 2)" class="message">
                        <div class="response">
                            <div class="text">
                                <a [href]="log.content" target="_blank">
                                    <img [src]="log.content" alt="Imagen adjunta" class="img-fluid" *ngIf="isImage(log.content); else fileLink">
                                    <ng-template #fileLink>
                                        <mat-icon>attach_file</mat-icon> {{ log.namereg || 'Descargar archivo' }}
                                    </ng-template>
                                </a>
                                <small>{{log.created_at | date : "dd/MM/yyyy hh:mm a" : "+0000"}}</small>
                            </div>
                        </div>
                        <div class="photo buho"></div>
                    </div>
                </ng-template>
            </div>
        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="w-100">

        <div *ngIf="previews.length > 0" class="d-flex flex-wrap gap-2 mb-2 px-3">
            <div *ngFor="let preview of previews; let i = index" class="preview-item d-flex align-items-center">
        
                <div class="preview-file-info d-flex align-items-center" [matTooltip]="preview.name">
                    <mat-icon>insert_drive_file</mat-icon>
                    <span class="file-name">{{ preview.name }}</span>
                </div>
                <button mat-icon-button class="remove-file-btn" (click)="removeFile(i)">
                    <mat-icon>cancel</mat-icon>
                </button>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-sm-9">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Escribe tu mensaje</mat-label>
                    <input matInput [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" required>
                </mat-form-field>
            </div>
                <!-- Botón para adjuntar archivo -->
            
                <!--<button mat-icon-button color="primary" (click)="fileInput.click()" matTooltip="Adjuntar archivo">
                    <mat-icon>attach_file</mat-icon>
                </button>-->
                <!-- Botón para enviar mensaje -->
                <!--<button mat-flat-button class="w-100" color="primary" (click)="sendMessage()" [disabled]="isLoading || (!newMessage.trim() && selectedFiles.length === 0)">Enviar <mat-icon>send</mat-icon></button>-->
                 <input type="file" #fileInput hidden multiple (change)="onFileSelected($event)">  
                 <div class="col-sm-1">
                     <button mat-flat-button class="mt-3 w-100" color="primary"(click)="fileInput.click()"  matTooltip="Adjuntar archivo"> <mat-icon>attach_file</mat-icon></button>
                 </div>
                 <div class="col-sm-2">
                     <button mat-flat-button class="mt-3 w-100" color="primary" (click)="sendMessage()" [disabled]="isLoading || (!newMessage.trim() && selectedFiles.length === 0)">Enviar <mat-icon>send</mat-icon></button>
                 </div>
        </div>
    </div>
</mat-dialog-actions>